<template>
  <div class="contain">
    <van-popup
      v-model="isShow"
      position="bottom"
      :style="{ height: '70%' }"
      @click-overlay="onClose"
      :close-on-click-overlay="false"
    >
      <div class="search-box">
        <van-search placeholder="请输关键字搜索" v-model="keywords" @input="onSearch" />
      </div>
      <div style="height:44px"></div>
      <div class="user-box">
        <div class="add-item" @click="memberAdd"  >
          新增裁判员
        </div>
        <van-cell-group v-if="options.length>0">
            <van-cell
              v-for="(item, index) in options"
              clickable
              :label="(item.sex==1? '男':'女')+' '+item.num +' '+item.grade"
              :key="index"
              @click="toggle(item)"
              :v-if="index < limit"
            >
              <template slot="title">
                <div class="custom-title">{{item.name}}</div>
              </template>
              <van-checkbox
                v-model="item.checked"
                slot="right-icon"
                :disabled="!item.grade"
                checked-color="#FD2840"
              />
            </van-cell>
          </van-cell-group>
        <div v-else class="noresult">
          没有记录...
        </div>
      </div>
      <div class="createbtn">
        <van-button type="danger" v-if="options.length==0 && !keywords"  native-type="button" size="large" v-rblink="{name:'CaipanList'}">新增裁判员</van-button>
        <van-button type="danger" v-else native-type="button" size="large" @click="onConfirm">确定</van-button>
      </div>



      <van-popup
              position="bottom"
              :style="{ height: '60%' }"
              v-model="addShow"
              @click-overlay="addShow=false"
      >
        <div style="margin-top: 0.2rem ; margin-bottom: 1.5rem">
          <van-form
                  @submit="onSubmit"
                  @failed="onFailed"
          >
            <van-divider>新增裁判员</van-divider>
            <van-cell-group>
              <van-field
                      v-model="formData.name"
                      label="姓名"
                      :rules="[{ required: true, message: '姓名不能为空' }]"
                      error-message-align="right"
                      input-align="right"
                      clearable
                      placeholder="请输入姓名"
              />
              <van-field
                      readonly
                      clickable
                      right-icon="arrow"
                      input-align="right"
                      @click="showNumTypePicker=true"
                      label="证件类型"
                      v-model="formData.numTypeName"
              />
              <van-popup v-model="showNumTypePicker" position="bottom">
                <van-picker :columns="numTypeColumns"
                            show-toolbar
                            :default-index="formData.cardtype-1"
                            @cancel="showNumTypePicker = false"
                            @confirm="onNumTypeConfirm"
                />
              </van-popup>



              <van-field
                      v-if="formData.cardtype==1"
                      v-model="formData.num"
                      :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                      error-message-align="right"
                      label="身份证号"
                      input-align="right"
                      clearable
                      placeholder="请输入身份证号"
              />

              <van-field
                      v-model="formData.huzhao"
                      v-if="formData.cardtype!=1"
                      label="证件号码"
                      :rules="[{ required: true, message: '证件号码不能为空' }]"
                      error-message-align="right"
                      input-align="right"
                      clearable
                      placeholder="请输入证件号码"
              />


              <van-field
                      v-model="formData.phone"
                      label="手机"
                      :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                      error-message-align="right"
                      input-align="right"
                      clearable
                      placeholder="请输入手机号"
              />

              <van-field
                      v-model="formData.email"
                      :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"
                      error-message-align="right"
                      label="邮箱"
                      input-align="right"
                      clearable
                      placeholder="请输入邮箱"
              />

              <van-field
                      v-model="formData.qq"
                      label="QQ"
                      error-message-align="right"
                      input-align="right"
                      clearable
                      placeholder="请输入QQ"
              />

              <van-field
                      v-model="formData.weixin"
                      label="微信"
                      error-message-align="right"
                      input-align="right"
                      clearable
                      placeholder="请输入微信"
              />

            </van-cell-group>

            <div class="savebtn">
              <van-button
                      color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                      style="width: 3rem"
                      size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." native-type="submit" >保存</van-button>
            </div>
          </van-form>
        </div>
      </van-popup>

    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import validator from "../../utils/validator";
import {
  Popup,
  Toast,
  Cell,
  CellGroup,
  Icon,
  Search,
  Checkbox,
  CheckboxGroup,
  DatetimePicker
} from "vant";

Vue.use(Popup)
  .use(Toast)
  .use(Cell)
  .use(CellGroup)
  .use(Icon)
  .use(Search)
  .use(Checkbox)
  .use(DatetimePicker)
  .use(CheckboxGroup);

export default {
  name: "CaipanPicker",
  props: {
    show: {
      type: Boolean,
      default: false
    },

    danweiId: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 1
    },

    defaultValue: {
      type: Array,
      default: () => []
    },

  },
  data() {
    return {
      validator,
      isShow: false,
      addShow:false,
      showDate: false,
      result: [],
      list:[],
      keywords: "",
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker:false,
      numTypeColumns: ['身份证', '护照','其他身份证明'],
      actions:[
        { name: '隐藏' },
        { name: '认证' },
      ],
      formData:{
        name:'',
        num:'',
        huzhao:'',
        cardtype:1,
        numTypeName:'身份证',
        phone:'',
        email:'',
        qq:'',
        weixin:'',
      },
      saveLoading:false,
    };
  },
  computed:{
    options(){
      let that = this;
      this.list.map((item,index) =>{
        if(that.resultIds.indexOf(item.num) ==-1){
          item.checked = false;
        }else{
          item.checked = true;
        }
      })

      return [...this.list];
    },
    resultIds(){
      return this.result.map((item,index) =>{
        return item.num
      })
    },

    showBirthday(){
      return this.formData.cardtype !=1 ;
    },
    showSex(){
      return this.formData.cardtype !=1 ;
    },
  },
  mounted() {
  },
  watch: {
    show(value) {
      this.isShow = value;
      if(value){
        this.onSearch();
        this.result = [...this.defaultValue];
      }
    },
    result(value){
      this.$emit("onChange",value);
    },

  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },

    toggle(item) {
      console.log('toggle',item.checked);
      if(!item.grade){
        Toast('该裁判没有新周期等级，无法申报随队裁判');
        return;
      }
      if(!item.checked){
        //选中
        if(this.limit ==1 ){
          //单选
          this.options.map(item=>{
            item.checked = false;
          })
          this.result = [];
        }else{
          //多选
          if(this.result.length >= this.limit ){
            Toast('最多不能超过'+(this.limit)+'个');
            return ;
          }

        }

      }
      item.checked =!item.checked ;
      if(item.checked){
        //add
        this.result.push(item);
      }else{
        //pen
        this.result = this.result.filter(val =>{
          return val.id != item.id
        });
      }
    },
    onSearch() {
      let that = this;
      that.$api.get(
              "/api/caipan/caipanOptions",
              { keywords: this.keywords,danwei_id:that.danweiId },
        res => {
          that.list = [...res.data];
        }
      );
    },

    onConfirm() {
      let that = this;
      console.log(that.result);
      that.$emit("onConfirm", that.result);
      that.isShow = false;
    },

    memberAdd(){
      this.addShow = true;
    },


    onDateConfirm(date){
      console.log('onDateConfirm',date);
      this.showDate = false;
      this.formData.birthday =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    submit(){

    },
    onNumTypeConfirm(value, index){
      this.formData.numTypeName = value;
      this.formData.cardtype = index+1;
      this.showNumTypePicker = false;
    },
    onFailed(errorInfo){
      console.log('failed', errorInfo);
    },
    onSubmit(values){
      console.log('onSubmit-values',values);
      console.log('submitType',this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;
      that.$api.post('/api/caipan/add', that.formData, (res) => {
        that.saveLoading = false;
        that.addShow = false;
        that.onSearch();
        that.formData = {
          name:'',
          num:'',
          huzhao:'',
          cardtype:1,
          numTypeName:'身份证',
          phone:'',
          email:'',
          qq:'',
          weixin:'',
        };
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
  }
};
</script>

<style scoped>

  .add-item{position: relative;/*padding: 10px 18px;*/padding: 15px 18px;color: #4A90E2;font-size: 14px;}
  .add-item:after{ content: ''; position: absolute; left: 0; right: 0; bottom: 0; border-bottom: 1px solid #d9d9d9; transform: scaleY(0.5); }

  .noresult{
    text-align: center;
    color: #666;
    padding-top: 1rem;
  }
.contain {
  position: relative;
}
.search-box {
  position: fixed;
  z-index: 999;
  width: 100%;
}
.van-search__content {
  background: #efeff4;
}

.user-box {
  margin-bottom: 50px;
}

.createbtn {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.cell-img {
  width: 48px;
  height: 48px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
}
  .savebtn {
    position: fixed;
    bottom: 0;
    padding-bottom: 0.2rem;
    width: 100%;
    z-index: 10;
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-around;
    background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
  }
</style>


// WEBPACK FOOTER //
// CaipanPicker.vue?4c32264e